import ChartWrapper from "src/components/chart/index";
import { LoadingPanel } from "src/components/loadingPanel";
import { dataParser, optimizeChartPayload } from "src/lib/widget.util";
import { useMemo } from "react";
import {
  DashboardChartRuleList,
  DashboardCompPlanConfig,
  DashboardDataset,
} from "src/service/query/dashboard-tab-list.query";
import {
  getDashboardPod,
  // mapDashboardComplanData,`
  mapDashboardDataSet,
  mapDashboardPodData,
} from "src/store/dashboard.store";
import { getUserData, mapUserData } from "src/store/user.store";

export const DashboardWidgetWrapperHook = (podDetail) => {
  const { tenantId, userKey, dbRoleTypeAbbr, acctEncryptKey } = mapUserData;
  const activeDashboardPod = getDashboardPod();
  // const { compPlanMstrKeys } = mapDashboardComplanData;
  const {
    tabId,
    dashboardTypeName,
    periodTypeMstrKey,
    reportPublishedFlag,
    dashboardPodKey,
    periodEndDate,
    periodStartDate,
    providerFilter,
    specialtyFilter,
    groupFilter,
    dashboardThemeName,
  } = mapDashboardPodData;
  const { chartType } = mapDashboardDataSet;

  const userData = getUserData();
  //let compPlanAccess = [];
  let renderBody = <LoadingPanel />;
  const DashboardCompPlanConfigData = DashboardCompPlanConfig({
    tenantId: tenantId.getData(userData) || null,
    dashboardTabMstrKey: tabId.getData(activeDashboardPod) || null,
    userKey: userKey.getData(userData) || null,
    dbRoleTypeAbbr: dbRoleTypeAbbr.getData(userData) || null,
  });
  const dashboardDataset = DashboardDataset({
    tenantId: tenantId.getData(userData) || null,
    dashboardPodKey: dashboardPodKey.getData(podDetail) || null,
    userKey: userKey.getData(userData) || null,
  });

  /*
  if (
    !DashboardCompPlanConfigData?.isLoading &&
    DashboardCompPlanConfigData?.data?.length > 0
  ) {
    compPlanAccess = DashboardCompPlanConfigData.data.map((compPlanObj) =>
      compPlanMstrKeys.getData(compPlanObj)
    );
  }
  */

  const removeDuplicatesFromString = (commaSeparatedString) => {
    if (!commaSeparatedString) {
      return "";
    }
    const array = commaSeparatedString.split(",");
    const uniqueArray = [...new Set(array)];
    const uniqueCommaSeparatedString = uniqueArray.join(",");
    return uniqueCommaSeparatedString;
  };

  const dedupedFilters = useMemo(
    () => ({
      groupFilter: removeDuplicatesFromString(groupFilter.getData(activeDashboardPod)),
      specialtyFilter: removeDuplicatesFromString(specialtyFilter.getData(activeDashboardPod)),
      providerFilter: removeDuplicatesFromString(providerFilter.getData(activeDashboardPod)),
    }),
    [activeDashboardPod, groupFilter, specialtyFilter, providerFilter]
  );

  const { data, isLoading } = DashboardChartRuleList({
    tenantId: tenantId.getData(userData) || null,
    userKey: userKey.getData(userData) || null,
    ruleResultTable: dashboardTypeName.getData(podDetail) || null,
    periodStartDate: periodStartDate.getData(activeDashboardPod) || null,
    periodEndDate: periodEndDate.getData(activeDashboardPod) || null,
    periodTypeMstrKey: periodTypeMstrKey.getData(podDetail) || null,
    encryptKey: acctEncryptKey.getData(userData) || null,
    groupFilter: dedupedFilters.groupFilter || null,
    specialtyFilter: dedupedFilters.specialtyFilter || null,
    providerFilter: dedupedFilters.providerFilter || null,
    dashboardTabMstrKey: tabId.getData(activeDashboardPod) || null,
    dashboardPodKey: dashboardPodKey.getData(podDetail) || null,
    reportPublishedFlag: reportPublishedFlag.getData(activeDashboardPod) || null,
  });

  const chartTheme = dashboardThemeName.getData(activeDashboardPod);
  const parsedChartPayload = useMemo(() => {
    const parsedData = dataParser({
      data,
      dataSetData: dashboardDataset?.data,
      chartTheme,
    });

    const optimizedData = optimizeChartPayload(parsedData);

    return {
      ...parsedData,
      ...optimizedData,
    };
  }, [data, dashboardDataset?.data, chartTheme]);

  if (data?.length > 0) {
    const { categoryAxisList, chartData, chartBackgroundColor, isSampled } = parsedChartPayload;

    const chartConfig = {
      chartCategories: categoryAxisList,
      chartBackgroundColor: chartBackgroundColor,
      mapChartType: chartType.getData,
      isSampled,
    };

    const isPODLoading = DashboardCompPlanConfigData?.isLoading || dashboardDataset?.isLoading;
    const isPODLoadingError = DashboardCompPlanConfigData?.isError || dashboardDataset?.isError;
    renderBody = isPODLoading ? (
      <LoadingPanel />
    ) : isPODLoadingError ? (
      <h4 className="center">No Data Found</h4>
    ) : (
      <ChartWrapper chartConfig={chartConfig} data={chartData} />
    );
  } else if (!DashboardCompPlanConfigData?.isLoading && !isLoading) {
    renderBody = <h4 className="center">No Data Found</h4>;
  }
  return {
    dashboardData: data,
    dataIsLoading: isLoading,
    renderBody,
  };
};
